import React from "react";

export default function Notifications() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Notifications</h1>
      <p>All company-wide announcements for you.</p>

      <ul className="mt-4 space-y-2">
        <li className="p-2 border rounded bg-gray-200">🎄 Company closed on Dec 25 (Christmas)</li>
        <li className="p-2 border rounded bg-gray-200">📅 Submit your feedback for HR portal updates</li>
      </ul>
    </div>
  );
}
